<template>
  <v-dialog
      v-model="dialog"
      max-width="320"
      persistent
  >
    <v-list
        class="py-2"
        color="primary"
        elevation="12"
        rounded="lg"
    >
      <v-list-item
          prepend-icon="$vuetify-outline"
          title="دریافت اطلاعات از سرور"
      >
        <template v-slot:prepend>
          <div class="pe-4">
            <v-icon color="primary" size="x-large"></v-icon>
          </div>
        </template>

        <template v-slot:append>
          <v-progress-circular
              color="primary"
              indeterminate="disable-shrink"
              size="16"
              width="2"
          ></v-progress-circular>
        </template>
      </v-list-item>
    </v-list>
  </v-dialog>
  <div class="text-center pa-4" style="direction: rtl">
    <v-dialog
        v-model="dialog1"
        max-width="400"
        persistent
    >
      <v-card
          prepend-icon="mdi-delete"
          text="آیا از حذف این محصول مطمئن هستید؟"
          title="حذف از سبد خرید"
          style="direction: rtl"
      >
        <template v-slot:actions>
          <v-spacer></v-spacer>



          <v-btn @click="deleteItemTrue()">
            بله
          </v-btn>
          <v-btn @click="dialog1 = false">
            خیر
          </v-btn>
        </template>
      </v-card>
    </v-dialog>
  </div>
  <v-main class="main" >
    <template  v-if="baskets.data.priceTotal > 0">
      <div style="padding: 30px 15px">
        <div class="col-12" style="display: flex;align-content: center;justify-content: center;direction: rtl;padding: 5px;text-align: center">

          <div class="col-2 float-right"></div>
          <div class="col-3 float-right">قیمت</div>
          <div class="col-3 float-right">مشخصات</div>
          <div class="col-3 float-right">تصویر</div>
        </div>
        <template v-for="(basket, index)  in baskets.data.items" :key="index">
          <div class="col-12 item" style="display: flex;align-content: center;justify-content: center;direction: rtl;text-align: center;height: 100px;background: #e8e8e8;margin: 5px 0;border-radius: 10px">
            <div v-if="!show" class="col-1 float-right deleteItem" @click="deleteItem(basket.id)" >
              <i class="fa-solid fa-trash"></i>
            </div>
            <div class="col-2 float-right"> {{basket.val}} <span class="uint_title">{{basket.product.uint_title}}</span> </div>
            <div class="col-3 float-right"><template v-if="basket.price_dis_format!=0"><span style="    text-decoration-line: line-through;">{{basket.price_dis_format}}</span><br/></template>{{basket.price_format}}</div>
            <div class="col-3 float-right">{{basket.product.cat_title}}<br/>{{basket.product.title}}</div>
            <div class="col-3 float-right"><img :src="basket.product.img_url"  style="width: 100%" /></div>
          </div>
        </template>
        <div v-if="!show" style="position: fixed;width: 300px;margin: 0 auto;bottom: 0;height: 180px;border-radius: 10px 10px 0 0;background: #1fa29d;padding: 10px;text-align: center;bottom: 60px" >
          <div style="font-size: 15px;color: #fff">جمع کل سبد : {{baskets.data.priceTotalDisShow}} ریال</div>
          <hr style="color: #fff"/>
          <div style="font-size: 15px;color: #fff">مبلغ با تخفیف : {{baskets.data.priceTotalShow}} ریال</div>
          <a href="/checkout">
            <div style="font-size: 15px;color: #1fa29d;padding: 5px;background: #fff;margin-top: 10px;border-radius: 10px;font-weight: 800">انتخاب آدرس و شیوه ارسال</div>
          </a>
        </div>
      </div>
    </template>
    <template  v-else>
      <div style="padding: 30px 15px">
        <div class="col-12" style="display: flex;align-content: center;justify-content: center;direction: rtl;padding: 5px;text-align: center;color: #1fa29d">
          سبد خرید خالی است
        </div>
      </div>
    </template>



  </v-main>
</template>

<script >
import {defineComponent} from "vue";
import HeaderApp from "@/views/headerApp.vue";
import FooterApp from "@/views/FooterApp.vue";
import http from "@/plugins/axios";
import router from "@/router";
import {formToJSON} from "axios";
var numeral = require("numeral");
export default defineComponent({
  name: 'cart-view',
  components: {FooterApp, HeaderApp},
  data: () => ({
    dialog: true,
    dialog1: false,
    baskets :  {
      data: [],
      total: [],
    },
    deleteItemid : 0,
    sum : 1000,

  }),
  methods: {
    deleteItemTrue(){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.post("/basket/delete",{
        basket_id : this.deleteItemid,
      }, { headers: { Authorization: AuthStr ,"Content-type": "multipart/form-data"} })
          .then(response => {
            this.dialog1=false;
            this.$toast.success("محصول با موفقیت از سبد خرید حذف شد.", {

              theme: "toasted-primary",
              position: "top-right",
              duration : 5000,

            });
            this.getCart();
          })
          .catch((error) => {

          });
    },
    deleteItem(id){
      this.dialog1=true;
      this.deleteItemid = id;
    },
    getCart() {
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/basket/get", { headers: { Authorization: AuthStr } })
          .then(response => {
            this.baskets = response.data;
            this.dialog= false;
            console.log( this.baskets.data);
          })
          .catch((error) => {
          });
    },
  },
  mounted() {
    this.getCart();
  },
  props: [
    "show",
  ],
});
</script>



<style scoped>
.main{
  padding: 60px 0 60px;
  height: calc(100% +100px);
}
  table{
    width: 90%;
    margin: 0 auto;
  }
table tr td{
  padding: 5px;
  text-align: center;
}
.del i{
  color: #7a0606;
  font-size: 18px;
}
.item{
  overflow: hidden;
}
.item div{
  align-content: center;
  padding: 5px;
}
.deleteItem{
  background: #7a0606;
}
.deleteItem i{
  color: #fff;
}
a{
  text-decoration: none;
}
.uint_title{
  font-size: 8px;
}
</style>